import styled from '../../utils/styled';
import { mediaBreakpointDownMD } from '../../../constants/style-constants';

export const ButtonContainer = styled.button(({ open, alternate }) => {
  const borderColor = alternate ? 'transparent' : '#343434';
  const backgroundColor = alternate ? 'transparent' : 'black';
  const hoverBackgroundColor = alternate ? 'transparent' : '#383838';
  const openBackgroundColor = alternate ? 'transparent' : '#101010';

  return {
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    width: '60px',
    height: '60px',
    padding: '0',
    margin: '0',
    border: 'none',
    borderLeft: `1px solid ${borderColor}`,
    borderBottom: `1px solid ${open ? 'transparent' : borderColor}`,
    cursor: 'pointer',
    backgroundColor: open ? openBackgroundColor : backgroundColor,
    transition: 'background-color 0.3s linear',

    '&:hover': {
      backgroundColor: hoverBackgroundColor,
    },

    [mediaBreakpointDownMD]: {
      display: 'flex',
    },

    '> img': {
      transition: 'transform 0.3s linear',
      transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
    },
  };
});

export const ButtonIcon = styled.img({
  display: 'block',
});
